import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const SeguroCancelacion = ({ onIncluirSeguroDeCancelacionClick }) => {
  return (
    <Fragment>
      <h2>Seguro de Cancelaci&oacute;n</h2>
      <hr />
      <h4>
        <i className="material-icons iconos-pagos">beenhere</i> El seguro de
        cancelación tiene un valor del 5% del total. Para contratarlo
        haga click abajo y estará aceptando las{" "}
        <Link to="/terminos-y-condiciones#seguro" target="_blank">
          condiciones
        </Link>{" "}
        del mismo
      </h4>
      <ul>
        <li>
          <input
            className="styled-checkbox"
            id="tos-seguro"
            name="seguroCancelacion"
            onChange={onIncluirSeguroDeCancelacionClick}
            type="checkbox"
          />
          <label htmlFor="tos-seguro">
            Agregar Seguro de Cancelaci&oacute;n
          </label>
        </li>
      </ul>
    </Fragment>
  );
};

export default SeguroCancelacion;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/PagoCdr/seguroCancelacion.js